(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-accessibility-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-userway-trigger]');
    if (!trigger) return;

    event.preventDefault();

    if (window.UserWay?.widgetOpen) {
      window.UserWay.widgetOpen();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
